import {Row, Col, Divider, ColorPicker, Select} from "antd";
import { useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { languages } from "../../../utils/helpers/constants";
import { getTranslations } from "../../../utils/helpers/translations";
import FieldBuilder from "../../form-components/field-builder";
import MainForm from "../../form-components/main-form";
import Spin from "../../general/antd/spin";
import OperationStoreCategoriesContext from "../../../context/operation-store-categories/context";
import OperationStoreCategoriesContextProvider from "../../../context/operation-store-categories/provider";
import { IUpdateOperationStoreCategories } from "../../../models/operation-store-categories/request";
import {Controller} from "react-hook-form";
import {getBannerType} from "../../../models/banner/enum";
import FormItem from "../../general/form-item";

const Form = () => {
  const { t } = useTranslation();
  const { details, actions, loading } = useContext(OperationStoreCategoriesContext);
  const { id } = useParams();

  useEffect(() => {
    const getDetails = async () => {
      id && (await actions.getDetails(Number(id)));
    };
    getDetails();
  }, []);

  return (
    <MainForm
      onSubmit={(data) => {
        details
          ? actions.updateOperationStoreCategories(details?.id, data)
          : actions.createOperationStoreCategories(data);
      }}
      title={details ? t("update_operation_store_categories") : t("add_operation_store_categories")}
      defaultValues={
        {
          name: getTranslations(details?.translations?.name),
          note: getTranslations(details?.translations?.note),
          color: details?.color,
        } as IUpdateOperationStoreCategories
      }
    >
      {loading.includes("details") ? (
        <div style={{ height: "50vh" }}>
          <Spin />
        </div>
      ) : (
        <>
          <Row gutter={[16, 8]}>
            {languages?.map((lang, index) => {
              return (
                <Col span={12}>
                  <FieldBuilder
                    key={index}
                    name={`name[${lang?.code}]`}
                    label={`${t("name")} (${lang?.name})`}
                    input={{ type: "text" }}
                    rules={{ required: true }}
                  />
                </Col>
              );
            })}
            {languages?.map((lang, index) => {
              return (
                <Col span={12}>
                  <FieldBuilder
                    key={index}
                    name={`note[${lang?.code}]`}
                    label={`${t("note")} (${lang?.name})`}
                    input={{ type: "text-area" }}
                    rules={{ required: false }}
                  />
                </Col>
              );
            })}
            <Col span={8}>
              <FormItem label={t("color")} required>
                <Controller
                    name="color"
                    rules={{ required: true }}
                    render={({ field: { onChange, value } }) => {
                      return (
                          <ColorPicker
                              value={value || details?.color}
                              onChange={(color) => onChange(color.toHexString())}
                          />
                      );
                    }}
                />
              </FormItem>
            </Col>
          </Row>
        </>
      )}
    </MainForm>
  );
};

const OperationStoreCategoriesForm = () => {
  return (
    <OperationStoreCategoriesContextProvider>
      <Form />
    </OperationStoreCategoriesContextProvider>
  );
};

export default OperationStoreCategoriesForm;